module.exports = __webpack_public_path__ + "static/img/introleft.cde5601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introleft.png
// module id = Ft/l
// module chunks = 0